/**
 * Short-window dedupe for back-to-back duplicate transaction-items fetches
 * (parent OrganisationDetails effect + transactions-tab fallback). The single
 * source of truth for "transaction items are loaded" lives on the organisation
 * object (`transactionItems !== undefined` after a successful fetch).
 */
const transactionItemsBurstAt = new Map<string, number>();

export function shouldSkipTransactionItemsBurst(
  organisationId: string,
  windowMs = 1500
): boolean {
  const now = Date.now();
  const lastAt = transactionItemsBurstAt.get(organisationId);
  if (lastAt != null && now - lastAt < windowMs) return true;
  transactionItemsBurstAt.set(organisationId, now);
  if (transactionItemsBurstAt.size > 200) {
    for (const [key, at] of transactionItemsBurstAt.entries()) {
      if (now - at > windowMs * 10) transactionItemsBurstAt.delete(key);
    }
  }
  return false;
}
